import { getAppConfig } from '@/plugins'

export const { appConfig } = getAppConfig()
